import { useState } from 'react'
import DateSelectionForm from '../DateSelectionForm'
import {CanadaProvinceList} from '../../app/constants'
import {GetProviceCodeFromName} from '../../app/utils'

const HistoryDetailsForm = (props) => {

    const id = props.id + "-licence-history"
    const [businessTypeText, setBusinessTypeText] = useState(props.businessLicenceType)
    const [provinceCode, setProvinceCode] = useState(GetProviceCodeFromName(props.province))
    const [startDate, setStartDate] = useState(props.startDate)
    const [endDate, setEndDate] = useState(props.endDate)

    const provinceOptionElements = []
    for (const key in CanadaProvinceList) {
        if (Object.hasOwnProperty.call(CanadaProvinceList, key)) {
            const element = CanadaProvinceList[key];
            provinceOptionElements.push(<option key={key} value={key}>{element}</option>)
        }
    }

    const isDateValid = (date) => {
        if(date <= 0) {
            return false
        }

        let dateObj = new Date(parseInt(date))
        const d = dateObj.getDate()

        if(d >= 1 && d <= 31) {
            const m = dateObj.getMonth() + 1
            if(m >= 1 && m <= 12) {
                const y = dateObj.getFullYear()
                if(y >= 1900 && y <= new Date().getFullYear()) {
                    return true
                }
            }
        }

        return false
    }

    const adjustEndDateFromStartDate = (date) => {
        return (date + (364 * 24 * 60 * 60 * 1000))
    }

    return (
        <div className="ns-fieldset" id={id + "-form"}>
            <div className="ns-fieldset">
                    <label
                        className="ns-label" 
                        id={id + "-business-licence-type-label"}
                        htmlFor={id + "-business-licence-type-text"}>
                            Type of business licence
                    </label>
                    <input
                        className="ns-input fw-20"
                        type="text"
                        id={id + "-business-licence-type-text"}
                        name={id + "-business-licence-type-text"}
                        value={businessTypeText}
                        onChange={(e) => {
                            setBusinessTypeText(e.target.value)
                            props.onDetailsChange({
                                id: props.id,
                                updatedDetails : {
                                    businessLicenceType : e.target.value
                                }
                            })
                        }}
                    />
            </div>
            <div className="ns-fieldset">
                <label
                    className="ns-label" 
                    id={id + "-province-select-label"}
                    htmlFor={id + "-province-select-input"}>
                        Province
                </label>
                <div className="select fw-20">
                    <select
                        id={id + "-province-select-input"}
                        name={id + "-province-select-input"}
                        value={provinceCode}
                        onChange={(e) => {
                                setProvinceCode(e.target.value)
                                props.onDetailsChange({
                                    id: props.id,
                                    updatedDetails : {
                                        province : CanadaProvinceList[e.target.value]
                                    }
                                })
                            }}>
                            {provinceOptionElements}
                    </select>
                </div>
            </div>
            <div className="ns-fieldset">
                <label
                    className="ns-label" 
                    id={id + "-start-date-label"}>
                        Start date
                </label>
                <DateSelectionForm 
                    id={id + "-start-date"} 
                    date={startDate}
                    onDateChange={(date) => {
                            setStartDate(date)
                            let adjustedEndDate = endDate
                            if(isDateValid(date)) {
                                adjustedEndDate = adjustEndDateFromStartDate(date)
                                setEndDate(adjustedEndDate)
                            }

                            props.onDetailsChange({
                                id: props.id,
                                updatedDetails : {
                                    startDate : date,
                                    endDate : adjustedEndDate
                                }
                            })
                        }} 
                />
            </div>
            <div className="ns-fieldset">
                <label
                    className="ns-label" 
                    id={id + "-start-date-label"}>
                        End date
                </label>
                <DateSelectionForm 
                    id={id + "-end-date"} 
                    date={endDate}
                    onDateChange={(date) => {
                            setEndDate(date)
                            props.onDetailsChange({
                                id: props.id,
                                updatedDetails : {
                                    endDate : date
                                }
                            })
                        }} 
                />
            </div>
        </div>
    )
}

export default HistoryDetailsForm